<template>
  <div class="page" id="page-cs">

    <div class="section-header">
      <div class="container">
        <h1>4대 공개 게시판</h1>
      </div>
    </div>

    <div class="section-body" id="bulletin-board">
      <div class="container">
        <div class="section-search">
          <div>
            <input class="searchBox" v-on:keyup.enter="search" v-model="searchText" />
            <img class="searchButton" :src="'../static/search.png'" >
          </div>

          <button v-if="!postStatus" @click="userValidate">글쓰기</button>

          <template v-if="postStatus">
            <element-select v-model="selectBoard.value" :label="selectBoard.label" :placeholder="selectBoard.placeholder" :items="selectBoard.items"/>
            <element-textbox v-model="subject.value" :label="subject.label" :placeholder="subject.placeholder" />
            <element-textarea v-model="post.value" :label="post.label" :placeholder="post.placeholder"/>
            <button @click="updateItem">게시물 등록</button>
          </template>
        </div>

        <div class="section-list">
          <element-tab>
            <element-tab-item @click="clickTab('Q&A')" :on="introductionTab == 'Q&A'">Q&A</element-tab-item>
            <element-tab-item @click="clickTab('잘하는군')" :on="introductionTab == '잘하는군'">잘하는군</element-tab-item>
            <element-tab-item @click="clickTab('똑바로해')" :on="introductionTab == '똑바로해'">똑바로해</element-tab-item>
            <element-tab-item @click="clickTab('바라는점')" :on="introductionTab == '바라는점'">바라는점</element-tab-item>
          </element-tab>

          <element-board>
            <element-board-item :key="index" v-for="(items, index) in data" @clickLazy="openItem != index ? updateClicks(items) : ''" @click="openItem === index ? openItem = -1 : openItem = index" :on="openItem == index">
              <p>{{ items.post_subject }}</p>
              <span>
                {{ "날짜 " }} {{ moment(items.createdAt).format('YYYY. MM. DD') }}
                &nbsp&nbsp
                {{ "조회수 " + items.post_view_count }}
              </span>
              <img :src="openItem == index ? '../static/expand_less_primary.png' : '../static/expand_more.png'" />

              <div class="item-description" v-if="openItem == index && items.post_content">
                {{ items.post_content }}
                
                  <div class="awnser" v-if="items.awnser">
                  <span>
                    {{ "날짜 " }} {{ moment(items.createdAt).format('YYYY. MM. DD') }}
                  </span>
                  {{ items.awnser }}
                  <div class="item-description-admin">
                    <div class="admin">
                    </div>
                    {{ items.admin }}
                  </div>
                </div>
              </div>
              <div class="item-description reply" style="border-top: 1px solid gray;" v-if="openItem == index && items.post_content_reply">
                <p>{{ items.post_content_reply }}</p>
              </div>
            </element-board-item>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              size="sm"
               @input =" updatePage(currentPage); "
              align="center">
            </b-pagination>
          </element-board>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
export default {
  data(){
    return {
      currentPage: 1,
      rows: 10,
      perPage: 10,
      moment: moment,
      openItem: -1,

      searchText: '',

      postStatus: false,

      subject: {
        value: '',
        error: '',
        label: '',
        placeholder: '제목을 입력해주세요.',
      },

      post: {
        value: '',
        error: '',
        label: '',
        placeholder: '내용을 입력해주세요.',
      },

      selectBoard: {
        value: 'board_qna',
        error: '',
        label: '게시판',
        placeholder: '게시판을 선택해 주세요',
        items: [
          { value: "board_qna", label: "Q&A" },
          { value: "board_good", label: "잘하는군" },
          { value: "board_problem", label: "똑바로해" },
          { value: "board_wish", label: "바라는점" }
        ]
      },


      introductionTab: 'Q&A',
      data: [
        { "id": "1", "title": "자동차보험 문의",  "description": "testtesttest", "awnser": "", "awnser_createAt": "", "admin": "", "createAt": "2019-04-09", "clicks": "13" },
        { "id": "2", "title": "문의", "description": "testtestttesttesttestt", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "3", "title": "사고 관련 상담 희망합니다.", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "4", "title": "보험료계산 문의", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "5", "title": "자동차보험 문의", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "6", "title": "상담 변경 부탁드립니다.", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "7", "title": "운전자보험 문의", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "8", "title": "유병자보험", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "9", "title": "실비보험 문의", "description": "실비보험을 오래전에 들은 거라 질병 통원비가 10만원 한도 내에서만 나오는거라 많이 약해 보강 좀 하려고 합니다. 제 담당자께서 정태현 설계사님이신데 전화 좀 부탁드릴께요.", "awnser": "고객님의 담당자인 정태현 상담원이 연락드려서 부족하신 부분에 대해서 확인 후 상담드리겠습니다. 감사합니다.", "awnser_createAt": "2019-04-09", "admin": "서은영",  "createAt": "2019-04-09", "clicks": "13" },
        { "id": "10", "title": "회원탈퇴 요청", "description": "", "awnser": "", "awnser_createAt": "", "admin": "",  "createAt": "2019-04-09", "clicks": "13" },
      ]
    }
  },
  created() {
    this.updatePage(1);
  },
  methods :{
    clickTab(tab){
      this.introductionTab = tab;

      this.updatePage(1);
    },
    userValidate(){
      if( this.$store.state.customer.profile._id ){
        this.postStatus = true;
      }
      else{
        this.$router.replace({ name: "Auth" });
      }
    },
    updateItem(){
      this.$store.dispatch( "post/updateItems", { subject: this.subject, post: this.post, board: this.selectBoard.value, user: this.$store.state.customer.profile } ).then( res => {
          alert("게시물이 등록되었습니다.");
          this.postStatus = false;
          this.subject.value = '';
          this.post.value = '';
          this.updatePage(1);
      })
    },
    search(evt){
      this.updatePage(1);
    },
    updateClicks(item){
      this.$store.dispatch( "post/updateClicks", { _id: item._id} ).then(res => {
        this.updatePage(this.currentPage);
      })
    },
    updatePage(page){
      this.$data.currentPage = page;

      this.$trackingService('init', '001-004-761');
      this.$trackingService('track', 'Search');

      if(this.introductionTab === 'Q&A'){
        this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "board_qna", search_text: this.searchText  } ).then( res => {
          this.data = res.data.data.items;

          this.rows = res.data.data.total;
        });
      }

      if(this.introductionTab === '잘하는군'){
        this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "board_good", search_text: this.searchText  } ).then( res => {
          this.data = res.data.data.items;

          this.rows = res.data.data.total;
        })
      }

      if(this.introductionTab === '바라는점'){
        this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "board_wish", search_text: this.searchText  } ).then( res => {
          this.data = res.data.data.items;


          this.rows = res.data.data.total;
        })
      }

      if(this.introductionTab === '똑바로해'){
        this.$store.dispatch( "post/getItems", { page: this.currentPage, size: 10, post_type: "board_problem", search_text: this.searchText  } ).then( res => {
          this.data = res.data.data.items;


          this.rows = res.data.data.total;
        })
      }

    }
  }
}
</script>
